import { Tab, Tabs } from '@resiliatech/birdsong'
import type { Tab as TabType, TabFilterKeyEnum } from '../types'

type TasksByGroupTabs = {
  activeTab: TabFilterKeyEnum
  onChangeTab: (tab: TabType) => void
  tabs: TabType[]
}

export const TasksByGroupTabs = ({
  activeTab,
  onChangeTab,
  tabs,
}: TasksByGroupTabs) => (
  <Tabs value={activeTab}>
    {tabs.map((tab) => (
      <Tab
        key={tab.label}
        label={`${tab.label} (${tab.count})`}
        onClick={() => onChangeTab(tab)}
        value={tab.filterKey}
        sx={{ textTransform: 'unset' }}
      />
    ))}
  </Tabs>
)
